import React, { useRef } from "react";
import { useGLTF, Center } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { MathUtils } from "three";

export function Kawabun(props) {
  const group = useRef()
  const groupInner = useRef()
  const { nodes } = useGLTF("/kawabun-logo.glb")
	useFrame((state) => {
    groupInner.current.children[0].children[0].children.forEach((child) => {
			const x = state.pointer.x * 2
			if(child.name === 'Curve004') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.12)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve005') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.11)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve006') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.09)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve007') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.08)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve008') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.07)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve009') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.06)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve010') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.05)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve001') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.07)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve002') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.05)
				child.rotation.z = rotation
			}
			if(child.name === 'Curve003') {
				const rotation = MathUtils.lerp(child.rotation.z, -x, 0.06)
				child.rotation.z = rotation
			}
    })
  })


  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
				
				<Center ref={groupInner}>
					<mesh
						name="Curve001"
						castShadow
						receiveShadow
						geometry={nodes.Curve001.geometry}
						material={nodes.Curve001.material}
						rotation-z={3}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>

					<mesh
						name="Curve003"
						geometry={nodes.Curve003.geometry}
						material={nodes.Curve003.material}
						rotation-z={3}
					>
						{/* <MeshRefractionMaterial bounces={3} aberrationStrength={0} envMap={texture} toneMapped={false} /> */}
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>

					<mesh
						name="Curve002"
						castShadow
						receiveShadow
						geometry={nodes.Curve002.geometry}
						material={nodes.Curve002.material}
						rotation-z={3}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>

					<mesh
						name="Curve005"
						castShadow
						receiveShadow
						geometry={nodes.Curve005.geometry}
						material={nodes.Curve005.material}
						rotation-z={3}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>

					<mesh
						name="Curve007"
						castShadow
						receiveShadow
						geometry={nodes.Curve007.geometry}
						material={nodes.Curve007.material}
						rotation-z={3}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>


					<mesh
						name="Curve006"
						castShadow
						receiveShadow
						geometry={nodes.Curve006.geometry}
						material={nodes.Curve006.material}
						rotation-z={3}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>


					<mesh
						name="Curve009"
						castShadow
						receiveShadow
						geometry={nodes.Curve009.geometry}
						material={nodes.Curve009.material}
						rotation-z={3}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>

					<mesh
						name="Curve010"
						castShadow
						receiveShadow
						geometry={nodes.Curve010.geometry}
						material={nodes.Curve010.material}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>


					<mesh
						name="Curve008"
						castShadow
						receiveShadow
						geometry={nodes.Curve008.geometry}
						material={nodes.Curve008.material}
						rotation-z={3}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>

					<mesh
						name="Curve004"
						castShadow
						receiveShadow
						geometry={nodes.Curve004.geometry}
						material={nodes.Curve004.material}
						rotation-z={3}
					>
						<meshStandardMaterial color={'#44615D'} roughness={0.11} metalness={0.453} reflectivity={0.657} clearcoat={0.66} clearcoatRoughness={0.12} />
					</mesh>

				</Center>
			
      </group>
    </group>
  );
}

useGLTF.preload("/kawabun-logo.glb");